module.exports = __webpack_public_path__ + "media/images/logo-1b2fb78596f1922fd8accea101b8dcee.png";